// src/routes/towermanagement.tsx
import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import { EEntity, EModule } from "@/components/table/filter/useTables";

// Páginas
const HomeTowerManagement = React.lazy(() => import("@/modules/towermanagement/pages/home"));
const PageDashboards = React.lazy(() => import("@/modules/towermanagement/pages/dashboard").then(m => ({ default: m.PageDashboards })));
const PageDashboard = React.lazy(() => import("@/modules/towermanagement/pages/dashboard/id").then(m => ({ default: m.PageDashboard })));

const PageCustomerRequesters = React.lazy(() => import("@/modules/towermanagement/pages/customerRequesters").then(m => ({ default: m.PageCustomerRequesters })));
const PageCustomerRequester = React.lazy(() => import("@/modules/towermanagement/pages/customerRequesters/id").then(m => ({ default: m.PageCustomerRequester })));

const PageCustomers = React.lazy(() => import("@/modules/towermanagement/pages/customer").then(m => ({ default: m.PageCustomers })));
const PageCustomer = React.lazy(() => import("@/modules/towermanagement/pages/customer/id").then(m => ({ default: m.PageCustomer })));

const PageSites = React.lazy(() => import("@/modules/towermanagement/pages/sites").then(m => ({ default: m.PageSites })));
const PageSite = React.lazy(() => import("@/modules/towermanagement/pages/sites/id").then(m => ({ default: m.PageSite })));

const PageTowers = React.lazy(() => import("@/modules/towermanagement/pages/towers").then(m => ({ default: m.PageTowers })));
const PageTower = React.lazy(() => import("@/modules/towermanagement/pages/towers/id"));

const PageMaintenances = React.lazy(() => import("@/modules/towermanagement/pages/maintenances").then(m => ({ default: m.PageMaintenances })));
const PageMaintenance = React.lazy(() => import("@/modules/towermanagement/pages/maintenances/id"));

const PageOutsourcedes = React.lazy(() => import("@/modules/towermanagement/pages/outsourcedes").then(m => ({ default: m.PageOutsourcedes })));
const PageOutsourced = React.lazy(() => import("@/modules/towermanagement/pages/outsourcedes/id"));
const PageTeam = React.lazy(() => import("@/modules/towermanagement/pages/teams/id"));


const PageRoutings = React.lazy(() => import("@/modules/towermanagement/pages/routings").then(m => ({ default: m.PageRoutings })));
const PageRouting = React.lazy(() => import("@/modules/towermanagement/pages/routings/id/id").then(m => ({ default: m.PageRouting })));

const PagePlanningsMaintenances = React.lazy(() => import("@/modules/towermanagement/pages/planningsMaintenances").then(m => ({ default: m.PagePlanningsMaintenances })));
const PagePlanningMaintenances = React.lazy(() => import("@/modules/towermanagement/pages/planningsMaintenances/id"));

const PageOrigins = React.lazy(() => import("@/modules/towermanagement/pages/origins").then(m => ({ default: m.PageOrigins })));
const PageServices = React.lazy(() => import("@/modules/towermanagement/pages/services").then(m => ({ default: m.PageServices })));

const PageUnitsOfMeasures = React.lazy(() => import("@/modules/towermanagement/pages/unitOfMeasure").then(m => ({ default: m.PageUnitsOfMeasures })));

const PageSLAs = React.lazy(() => import("@/modules/towermanagement/pages/sla").then(m => ({ default: m.PageSLAs })));
const PageSLA = React.lazy(() => import("@/modules/towermanagement/pages/sla/id"));
const PageSLARule = React.lazy(() => import("@/modules/towermanagement/pages/slaRules/id"));

const PagePathologies = React.lazy(() => import("@/modules/towermanagement/pages/pathologies").then(m => ({ default: m.PagePathologies })));

const PageScope = React.lazy(() => import("@/modules/towermanagement/pages/scopes/id"));

const PageActivities = React.lazy(() => import("@/modules/towermanagement/pages/activities").then(m => ({ default: m.PageActivities })));
const PageActivity = React.lazy(() => import("@/modules/towermanagement/pages/activities/id"));
const PageStages = React.lazy(() => import("@/modules/towermanagement/pages/stages").then(m => ({ default: m.PageStages })));

const PageStatuses = React.lazy(() => import("@/modules/towermanagement/pages/statuses").then(m => ({ default: m.PageStatuses })));
const PageStatus = React.lazy(() => import("@/modules/towermanagement/pages/statuses/id"));

// EHS (Environment, Health and Safety)
const PageEhsDocumentTypes = React.lazy(() => import("@/modules/towermanagement/pages/outsourcedes/ehsDocumentTypes").then(m => ({ default: m.PageEhsDocumentTypes })));
const PageEhsDocumentType = React.lazy(() => import("@/modules/towermanagement/pages/outsourcedes/ehsDocumentTypes/id"));
const PageEhs = React.lazy(() => import("@/modules/towermanagement/pages/ehs").then(m => ({ default: m.PageEhs })));

const PageOccurrence = React.lazy(() => import("@/modules/towermanagement/pages/occurrences/id"));

const PageItems = React.lazy(() => import("@/modules/towermanagement/pages/items").then(m => ({ default: m.PageItems })));

const PageMeasurements = React.lazy(() => import("@/modules/towermanagement/pages/measurements").then(m => ({ default: m.PageMeasurements })));
const PageMeasurement = React.lazy(() => import("@/modules/towermanagement/pages/measurements/id"));
const PageMeasurementResume = React.lazy(() => import("@/modules/towermanagement/pages/measurements/resume/id"));
const PageMeasurementsOverview = React.lazy(() => import("@/modules/towermanagement/pages/measurements/overview").then(m => ({ default: m.PageMeasurementsOverview })));
const PageMeasurementsOverviewReceivable = React.lazy(() => import("@/modules/towermanagement/pages/measurements/overview-receivable").then(m => ({ default: m.PageMeasurementsOverviewReceivable })));
const PageOutsourcedResume = React.lazy(() => import("@/modules/towermanagement/pages/measurements/outsourced-resume").then(m => ({ default: m.PageOutsourcedResume })));
const PageFinancialControl = React.lazy(() => import("@/modules/towermanagement/pages/measurements/financial-control").then(m => ({ default: m.PageFinancialControl })));

const PageContract = React.lazy(() => import("@/modules/towermanagement/pages/contracts/id"));
const PageContractValue = React.lazy(() => import("@/modules/towermanagement/pages/contracts/values/id"));
const PageContractPeriodicity = React.lazy(() => import("@/modules/towermanagement/pages/contracts/periodicities/id"));

const PagePricingPlans = React.lazy(() => import("@/modules/towermanagement/pages/pricingPlans").then(m => ({ default: m.PagePricingPlans })));
const PagePricingPlan = React.lazy(() => import("@/modules/towermanagement/pages/pricingPlans/id"));
const PagePricingValue = React.lazy(() => import("@/modules/towermanagement/pages/pricingPlans/values/id"));

const PageApprovalFlowSteps = React.lazy(() => import("@/modules/towermanagement/pages/steps").then(m => ({ default: m.PageApprovalFlowSteps })));

const PageFormResponses = React.lazy(() => import("@/modules/towermanagement/pages/formResponses").then(m => ({ default: m.PageFormResponses })));
const PageFormResponse = React.lazy(() => import("@/modules/towermanagement/pages/formResponses/id").then(m => ({ default: m.PageFormResponse })));

const PageForm = React.lazy(() => import("@/modules/towermanagement/pages/formBuilder/components").then(m => ({ default: m.PageForm })));
const PageForms = React.lazy(() => import("@/modules/towermanagement/pages/forms/form"));

const PageApprovalFlowsMaster = React.lazy(() => import("@/modules/towermanagement/pages/approvalFlows").then(m => ({ default: m.PageApprovalFlowsMaster })));
const PageApprovalFlowBuilder = React.lazy(() => import("@/modules/towermanagement/pages/approvalFlows/builder/PageFlowBuilder").then(m => ({ default: m.PageApprovalFlowBuilder })));

const PageAttributions = React.lazy(() => import("@/modules/towermanagement/pages/attributions").then(m => ({ default: m.PageAttributions })));
const PageLocationsHistory = React.lazy(() => import("@/modules/global/pages/timeLine").then(m => ({ default: m.PageLocationsHistory })));

const PageEquipmentCategories = React.lazy(() => import("@/modules/towermanagement/pages/equipmentCategories").then(m => ({ default: m.PageEquipmentCategories })));
const PageEquipments = React.lazy(() => import("@/modules/towermanagement/pages/equipments"));
const PageEquipmentModels = React.lazy(() => import("@/modules/towermanagement/pages/equipmentModel").then(m => ({ default: m.PageEquipmentModels })));
const PageAccessRequests = React.lazy(() => import("@/modules/towermanagement/pages/accessRequests").then(m => ({ default: m.PageAccessRequests })));

type Def = {
  path: string;
  element: React.ReactElement;
  auth: boolean;
  entity?: EEntity;
};

const wrap = ({ auth, entity, element }: Omit<Def, "path">) => (
  <React.Suspense fallback={<>Carregando...</>}>
    <ProtectedRoute
      auth={auth}
      {...(auth ? { module: EModule.TOWERMANAGEMENT, entity } : {})}
    >
      {element}
    </ProtectedRoute>
  </React.Suspense>
);

// Definições de rotas (agrupadas por seção)
// -------------------------------------------------------
const home: Def[] = [
  { path: "/towermanagement", auth: false, element: <HomeTowerManagement /> },
];

const dashboards: Def[] = [
  {
    path: "/towermanagement/dashboards",
    auth: false,
    element: <PageDashboards />,
  },
  {
    path: "/towermanagement/dashboards/:idDashboard",
    auth: false,
    element: <PageDashboard />,
  },
];

const customerRequesters: Def[] = [
  {
    path: "/towermanagement/customer_requesters",
    auth: false,
    element: <PageCustomerRequesters />,
  },
  {
    path: "/towermanagement/customer_requesters/:idCustomerRequester",
    auth: false,
    element: <PageCustomerRequester />,
  },
  {
    path: "/towermanagement/customers/:idCustomer/requesters/:idCustomerRequester",
    auth: false,
    element: <PageCustomerRequester />,
  },
];

const customers: Def[] = [
  {
    path: "/towermanagement/customers",
    auth: true,
    entity: EEntity.TWM_CUSTOMERS,
    element: <PageCustomers />,
  },
  {
    path: "/towermanagement/customers/:idCustomer",
    auth: true,
    entity: EEntity.TWM_CUSTOMERS,
    element: <PageCustomer />,
  },
];

const sites: Def[] = [
  {
    path: "/towermanagement/sites",
    auth: true,
    entity: EEntity.TWM_SITES,
    element: <PageSites />,
  },
  {
    path: "/towermanagement/sites/:idSite",
    auth: true,
    entity: EEntity.TWM_SITES,
    element: <PageSite />,
  },
];

const towers: Def[] = [
  {
    path: "/towermanagement/towers",
    auth: true,
    entity: EEntity.TWM_TOWERS,
    element: <PageTowers />,
  },
  {
    path: "/towermanagement/towers/:id",
    auth: true,
    entity: EEntity.TWM_TOWERS,
    element: <PageTower />,
  },
];

const maintenances: Def[] = [
  {
    path: "/towermanagement/maintenances",
    auth: true,
    entity: EEntity.TWM_MAINTENANCES,
    element: <PageMaintenances />,
  },
  {
    path: "/towermanagement/maintenances/:id",
    auth: true,
    entity: EEntity.TWM_MAINTENANCES,
    element: <PageMaintenance />,
  },
];

const outsourcedes: Def[] = [
  {
    path: "/towermanagement/outsourcedes",
    auth: true,
    entity: EEntity.TWM_OUTSOURCEDES,
    element: <PageOutsourcedes />,
  },
  {
    path: "/towermanagement/outsourcedes/:idOutsourced",
    auth: true,
    entity: EEntity.TWM_OUTSOURCEDES,
    element: <PageOutsourced />,
  },
  {
    path: "/towermanagement/outsourcedes/:idOutsourced/teams/:id",
    auth: true,
    entity: EEntity.TWM_TEAMS,
    element: <PageTeam />,
  },
  {
    path: "/towermanagement/outsourcedes/teams/:id",
    auth: true,
    entity: EEntity.TWM_TEAMS,
    element: <PageTeam />,
  },
  {
    path: "/towermanagement/outsourcedes/:idOutsourced/contracts/:idContract",
    auth: true,
    entity: EEntity.TWM_CONTRACTS,
    element: <PageContract />,
  },
  {
    path: "/towermanagement/outsourcedes/:idOutsourced/ehs-documents/:idEhsDocumentFile",
    auth: true,
    entity: EEntity.TWM_EHS_DOCUMENTS,
    element: <PageOutsourced />,
  },
];

// Cadastros de equipamentos
const cadastrosChildren: Def[] = [
  {
    path: "/towermanagement/equipments",
    auth: true,
    entity: EEntity.TWM_EQUIPMENTS,
    element: <PageEquipments />,
  },
  // APAGAMOS A ROTA DO /new QUE FICAVA AQUI!
  {
    path: "/towermanagement/equipments/:idEquipment",
    auth: true,
    entity: EEntity.TWM_EQUIPMENTS,
    element: <PageEquipments />,
  },
  {
    path: "/towermanagement/equipments/categoryEquipment/:idCategoryEquipment",
    auth: true,
    entity: EEntity.TWM_CATEGORYEQUIPMENT,
    element: <PageEquipmentCategories />,
  },
  {
    path: "/towermanagement/equipments/categoryEquipment",
    auth: true,
    entity: EEntity.TWM_CATEGORYEQUIPMENT,
    element: <PageEquipmentCategories />,
  },
  {
    path: "/towermanagement/equipments/equipmentModels",
    auth: true,
    entity: EEntity.TWM_EQUIPMENTMODELS,
    element: <PageEquipmentModels />,
  },
  {
    path: "/towermanagement/equipments/equipmentModels/:idEquipmentModel",
    auth: true,
    entity: EEntity.TWM_EQUIPMENTMODELS,
    element: <PageEquipmentModels />,
  },

];

// EHS
const ehsRoutes: Def[] = [
  {
    path: "/towermanagement/ehs",
    auth: true,
    entity: EEntity.TWM_EHS,
    element: <PageEhs />,
  },
  {
    path: "/towermanagement/ehs-document-types",
    auth: true,
    entity: EEntity.TWM_EHS_DOCUMENT_TYPES,
    element: <PageEhsDocumentTypes />,
  },
  {
    path: "/towermanagement/ehs-document-types/:id",
    auth: true,
    entity: EEntity.TWM_EHS_DOCUMENT_TYPES,
    element: <PageEhsDocumentType />,
  },
];

const routings: Def[] = [
  {
    path: "/towermanagement/routings",
    auth: true,
    entity: EEntity.TWM_ROUTINGS,
    element: <PageRoutings />,
  },
  {
    path: "/towermanagement/routings/:id",
    auth: true,
    entity: EEntity.TWM_ROUTINGS,
    element: <PageRouting />,
  },
];

const plannings: Def[] = [
  {
    path: "/towermanagement/plannings_maintenances",
    auth: true,
    entity: EEntity.TWM_PLANNINGSMAINTENANCES,
    element: <PagePlanningsMaintenances />,
  },
  {
    path: "/towermanagement/plannings_maintenances/:idPlanningMaintenance",
    auth: true,
    entity: EEntity.TWM_PLANNINGSMAINTENANCES,
    element: <PagePlanningMaintenances />,
  },
];

const servicesScopes: Def[] = [
  {
    path: "/towermanagement/services",
    auth: true,
    entity: EEntity.TWM_SERVICES,
    element: <PageServices />,
  },
  {
    path: "/towermanagement/services/:idService",
    auth: true,
    entity: EEntity.TWM_SERVICES,
    element: <PageServices />,
  },
  {
    path: "/towermanagement/services/:idService/scopes/:id",
    auth: true,
    entity: EEntity.TWM_SCOPES,
    element: <PageScope />,
  },
  {
    path: "/towermanagement/scopes/:id",
    auth: true,
    entity: EEntity.TWM_SCOPES,
    element: <PageScope />,
  },
];

const origins: Def[] = [
  {
    path: "/towermanagement/origins",
    auth: true,
    entity: EEntity.TWM_ORIGINS,
    element: <PageOrigins />,
  },
  {
    path: "/towermanagement/origins/:idOrigin",
    auth: true,
    entity: EEntity.TWM_ORIGINS,
    element: <PageOrigins />,
  },
];

const slas: Def[] = [
  {
    path: "/towermanagement/slas",
    auth: true,
    entity: EEntity.TWM_SLAS,
    element: <PageSLAs />,
  },
  {
    path: "/towermanagement/slas/:idSLA",
    auth: true,
    entity: EEntity.TWM_SLAS,
    element: <PageSLA />,
  },
  {
    path: "/towermanagement/slas/:idSLA/rules/:idSLARule",
    auth: true,
    entity: EEntity.TWM_SLAS,
    element: <PageSLARule />,
  },
];

const pathologies: Def[] = [
  {
    path: "/towermanagement/pathologies",
    auth: true,
    entity: EEntity.TWM_PATHOLOGIES,
    element: <PagePathologies />,
  },
];

const activities: Def[] = [
  {
    path: "/towermanagement/maintenances/:idMaintenance/activities/:idActivity",
    auth: true,
    entity: EEntity.TWM_ACTIVITIES,
    element: <PageActivity />,
  },
  {
    path: "/towermanagement/activities",
    auth: true,
    entity: EEntity.TWM_ACTIVITIES,
    element: <PageActivities filter={{}} />,
  },
  {
    path: "/towermanagement/activities/:idActivity",
    auth: true,
    entity: EEntity.TWM_ACTIVITIES,
    element: <PageActivity />,
  },
  {
    path: "/towermanagement/activities/:idActivity/activityEntries",
    auth: true,
    entity: EEntity.TWM_ACTIVITIES,
    element: <PageActivity />,
  },
  {
    path: "/towermanagement/activities/:idActivity/entries/:idEntry",
    auth: true,
    entity: EEntity.TWM_ACTIVITIES,
    element: <PageActivity />,
  },
];

const statuses: Def[] = [
  {
    path: "/towermanagement/statuses",
    auth: true,
    entity: EEntity.TWM_STATUSES,
    element: <PageStatuses />,
  },
  {
    path: "/towermanagement/statuses/:id",
    auth: true,
    entity: EEntity.TWM_STATUSES,
    element: <PageStatus />,
  },
];

const stagesRoutes: Def[] = [
  {
    path: "/towermanagement/stages",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageStages />,
  },
  {
    path: "/towermanagement/stages/:idStage",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageStages />,
  },
];

const occurrences: Def[] = [
  {
    path: "/towermanagement/occurrences/:idOccurrence",
    auth: true,
    entity: EEntity.TWM_OCCURRENCES,
    element: <PageOccurrence />,
  },
  {
    path: "/towermanagement/activities/:idActivity/occurrences/:idOccurrence",
    auth: true,
    entity: EEntity.TWM_OCCURRENCES,
    element: <PageOccurrence />,
  },
];

const items: Def[] = [
  {
    path: "/towermanagement/items",
    auth: true,
    entity: EEntity.TWM_ITEMS,
    element: <PageItems />,
  },
  {
    path: "/towermanagement/items/:idItem",
    auth: true,
    entity: EEntity.TWM_ITEMS,
    element: <PageItems />,
  },
];

const measurements: Def[] = [
  {
    path: "/towermanagement/measurements",
    auth: true,
    entity: EEntity.TWM_MEASUREMENTS,
    element: <PageMeasurements />,
  },
  {
    path: "/towermanagement/measurements/overview",
    auth: true,
    entity: EEntity.TWM_MEASUREMENTS,
    element: <PageMeasurementsOverview />,
  },
  {
    path: "/towermanagement/measurements/overview/outsourced/:idOutsourced",
    auth: true,
    entity: EEntity.TWM_MEASUREMENTS,
    element: <PageOutsourcedResume />,
  },
  {
    path: "/towermanagement/measurements/overview-receivable",
    auth: true,
    entity: EEntity.TWM_MEASUREMENTS,
    element: <PageMeasurementsOverviewReceivable />,
  },
  {
    path: "/towermanagement/measurements/financial-control",
    auth: true,
    entity: EEntity.TWM_MEASUREMENTS,
    element: <PageFinancialControl />,
  },
  {
    path: "/towermanagement/measurements/:idMeasurement",
    auth: true,
    entity: EEntity.TWM_MEASUREMENTS,
    element: <PageMeasurement />,
  },
  {
    path: "/towermanagement/measurements/:idMeasurement/resume",
    auth: true,
    entity: EEntity.TWM_MEASUREMENTS,
    element: <PageMeasurementResume />,
  },
];

const contractsPricing: Def[] = [
  {
    path: "/towermanagement/contracts/:idContract",
    auth: true,
    entity: EEntity.TWM_CONTRACTS,
    element: <PageContract />,
  },
  {
    path: "/towermanagement/customers/:idCustomer/contracts/:idContract",
    auth: true,
    entity: EEntity.TWM_CONTRACTS,
    element: <PageContract />,
  },
  {
    path: "/towermanagement/contracts/:idContract/contract_values/:idContractValue",
    auth: true,
    entity: EEntity.TWM_CONTRACTVALUES,
    element: <PageContractValue />,
  },
  {
    path: "/towermanagement/contracts/:idContract/contract_periodicities/:idContractPeriodicity",
    auth: true,
    entity: EEntity.TWM_CONTRACTVALUES,
    element: <PageContractPeriodicity />,
  },

  {
    path: "/towermanagement/pricing_plans",
    auth: true,
    entity: EEntity.TWM_PRICINGPLANS,
    element: <PagePricingPlans />,
  },
  {
    path: "/towermanagement/pricing_plans/:idPricingPlan",
    auth: true,
    entity: EEntity.TWM_PRICINGPLANS,
    element: <PagePricingPlan />,
  },
  {
    path: "/towermanagement/pricing_plans/:idPricingPlan/pricing_values/:idPricingValue",
    auth: true,
    entity: EEntity.TWM_PRICINGVALUES,
    element: <PagePricingValue />,
  },
];

const stepsForms: Def[] = [
  {
    path: "/towermanagement/approval_flow_execution_steps",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageApprovalFlowSteps />,
  },
  {
    path: "/towermanagement/forms",
    auth: true,
    entity: EEntity.TWM_FORMS,
    element: <PageForms />,
  },
  {
    path: "/towermanagement/forms/:idForm",
    auth: true,
    entity: EEntity.TWM_FORMS,
    element: <PageForm />,
  },
  {
    path: "/towermanagement/forms/:idForm/categories",
    auth: true,
    entity: EEntity.TWM_FORMS,
    element: <PageForm />,
  },
  {
    path: "/towermanagement/forms/:idForm/categories/:idCategoryForm",
    auth: true,
    entity: EEntity.TWM_FORMS,
    element: <PageForm />,
  },
  {
    path: "/towermanagement/forms/:idForm/fields",
    auth: true,
    entity: EEntity.TWM_FORMS,
    element: <PageForm />,
  },
  {
    path: "/towermanagement/forms/:idForm/fields/:idField",
    auth: true,
    entity: EEntity.TWM_FORMS,
    element: <PageForm />,
  },
  {
    path: "/towermanagement/forms/:idForm/conditions",
    auth: true,
    entity: EEntity.TWM_FORMS,
    element: <PageForm />,
  },
  {
    path: "/towermanagement/forms/:idForm/conditions/:idFormAssignmentCondition",
    auth: true,
    entity: EEntity.TWM_FORMS,
    element: <PageForm />,
  },
  {
    path: "/towermanagement/formResponses",
    auth: true,
    entity: EEntity.TWM_ROUTES,
    element: <PageFormResponses />,
  },
  {
    path: "/towermanagement/formResponses/:idFormResponse",
    auth: true,
    entity: EEntity.TWM_ROUTES,
    element: <PageFormResponse />,
  },
  {
    path: "/towermanagement/approval-flows",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageApprovalFlowsMaster />,
  },
  {
    path: "/towermanagement/approvalFlows",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageApprovalFlowsMaster />,
  },
  {
    path: "/towermanagement/approval-flows/:idApprovalFlow/builder",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageApprovalFlowBuilder />,
  },
  {
    path: "/towermanagement/approvalFlows/:idApprovalFlow/builder",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageApprovalFlowBuilder />,
  },
  {
    path: "/towermanagement/approval-flows/:idApprovalFlow",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageApprovalFlowsMaster />,
  },
  {
    path: "/towermanagement/approvalFlows/:idApprovalFlow",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageApprovalFlowsMaster />,
  },
  {
    path: "/towermanagement/approval-flows/new",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageApprovalFlowsMaster />,
  },
  {
    path: "/towermanagement/approvalFlows/new",
    auth: true,
    entity: EEntity.TWM_APPROVALFLOWEXECUTIONSTEPS,
    element: <PageApprovalFlowsMaster />,
  },
];

const attributions = [
  {
    path: "/towermanagement/attributions",
    auth: true,
    entity: EEntity.TWM_ROUTINGS,
    element: <PageAttributions />,
  },
];

const locationsHistory = [
  {
    path: "/towermanagement/timeline",
    auth: true,
    entity: EEntity.TWM_LOCATIONSHISTORY,
    element: <PageLocationsHistory />,
  },
];

const unitsOfMeasure: Def[] = [
  {
    path: "/towermanagement/unitOfMeasures",
    auth: true,
    entity: EEntity.TWM_SERVICES,
    element: <PageUnitsOfMeasures />,
  },
  {
    path: "/towermanagement/unitOfMeasures/:idUnitOfMeasure",
    auth: true,
    entity: EEntity.TWM_SERVICES,
    element: <PageUnitsOfMeasures />,
  },
];

const accessRequests: Def[] = [
  {
    path: "/towermanagement/access-requests",
    auth: true,
    entity: EEntity.TWM_ACCESS_REQUESTS,
    element: <PageAccessRequests />,
  },
  {
    path: "/towermanagement/access-requests/requests",
    auth: true,
    entity: EEntity.TWM_ACCESS_REQUESTS,
    element: <PageAccessRequests />,
  },
  {
    path: "/towermanagement/access-requests/pending",
    auth: true,
    entity: EEntity.TWM_ACCESS_REQUESTS,
    element: <PageAccessRequests />,
  },
  {
    path: "/towermanagement/access-requests/assignments",
    auth: true,
    entity: EEntity.TWM_ACCESS_REQUESTS,
    element: <PageAccessRequests />,
  },
];

// Exports
// -------------------------------------------------------
const defs: Def[] = [
  ...home,
  ...dashboards,
  ...customerRequesters,
  ...customers,
  ...sites,
  ...towers,
  ...maintenances,
  ...outsourcedes,
  ...routings,
  ...plannings,
  ...servicesScopes,
  ...origins,
  ...slas,
  ...pathologies,
  ...activities,
  ...stagesRoutes,
  ...statuses,
  ...occurrences,
  ...items,
  ...measurements,
  ...contractsPricing,
  ...stepsForms,
  ...attributions,
  ...locationsHistory,
  ...unitsOfMeasure,
  ...accessRequests,
  ...ehsRoutes,
  ...cadastrosChildren,
];

export const towerManagementRoutes = defs.map(({ path, ...rest }) => (
  <Route key={path} path={path} element={wrap(rest)} />
));
